import { defineAsyncComponent as e } from "vue";
import { registerEntityEndpoint as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: { chipWidget: {
		contentBlockLabel: "Widget",
		inputIDLabel: "Widget ID (CWC-ID)",
		inputTypeLabel: "Widget type",
		openConfiguratorButton: "Widget configurator",
		InvalidWidgetType: "{widget} is not part of available widget types. Please select another widget.",
		widgetTypeNotAllowed: "This widget type is not allowed."
	} },
	de: { chipWidget: {
		contentBlockLabel: "Widget",
		inputIDLabel: "Widget-ID (CWC-ID)",
		inputTypeLabel: "Widget-Typ",
		openConfiguratorButton: "Widget-Konfigurator",
		InvalidWidgetType: "Widget-Typ {widget} ist nicht verfügbar. Bitte ein anderes Widget wählen.",
		widgetTypeNotAllowed: "Dieser Widget-Typ ist nicht erlaubt."
	} }
}, r = "chip-widget", i = t(r), { getEntity: a, postEntity: o } = i, s = async (e) => a(e), c = async (e) => o({ ...e }), l = () => [
	"pro-con-list",
	"top-list",
	"table",
	"ir-boost-list",
	"deal-widget"
], u = e(() => import("./chip-widget-block-CnZr8Z8a.js")), d = {
	messages: n,
	routes: [],
	contentBlocks: [{
		type: "CHIP_WIDGET",
		label: "chipWidget.contentBlockLabel",
		icon: "note",
		component: u,
		defaultValue: { type: "CHIP_WIDGET" }
	}]
};
//#endregion
export { u as ChipWidgetBlock, r as ChipWidgetModelName, d as ChipWidgetModule, i as ChipWidgetService, l as getAllowedWidgetTypes, s as getChipWidget, c as postChipWidget };

//# sourceMappingURL=index.es.js.map